import withErrorBoundary from '../../../../../ErrorBoundary/withErrorBoundary';
import {Menu} from '../Menu/Menu';

export const MenuWithErrorBoundary = withErrorBoundary(null)(Menu);
